<template>
  <MultiLineButton @click="edit" :text="text" />
</template>

<script>
import MultiLineButton from '@/components/buttons/MultiLineButton'
export default {
  components: {
    MultiLineButton
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: null
    }
  },

  methods: {
    edit() {
      this.$store.commit('UPDATE_SHOOTING_EDITION_MODE', {
        editionTypeSelected: this.type,
        isEditMode: true,
        selectedImages: []
      })
    }
  }
}
</script>
